export enum HearFromValues {
  searchEngine = 1,
  reviewSite = 2,
  socialMedia = 3,
  wordOfMouth = 4,
  square = 5,
  anotherCompanyWebsiteOrBlog = 6,
  other = 7,
}

export const numberHearFromToString = {
  [HearFromValues.searchEngine]: 'Search Engine',
  [HearFromValues.reviewSite]: 'Review Site',
  [HearFromValues.socialMedia]: 'Social Media',
  [HearFromValues.wordOfMouth]: 'Word of mouth',
  [HearFromValues.square]: 'Square',
  [HearFromValues.anotherCompanyWebsiteOrBlog]: 'Another company’s website or blog',
  [HearFromValues.other]: 'Other',
};
